export type RoleName = "super_admin" | "user_management" | "image_builder" | "class_admin" | "default";

export interface User {
  id: string;
  email: string;
  is_active: boolean;
  roles: RoleName[];
  created_at: string;
  updated_at: string;
}

export const CQRM_ACCESS_ROLES: RoleName[] = ["user_management", "super_admin"];
